import { jsx as _jsx } from "react/jsx-runtime";
import { cva, css as designCss } from '@reservoir0x/relay-design-system/css';
const BoxCss = cva({});
const Box = ({ css, children, id, ...props }) => {
    return (_jsx("div", { className: designCss(BoxCss.raw(props), designCss.raw(css)), id: id, children: children }));
};
export default Box;
//# sourceMappingURL=Box.js.map